import React from 'react';

// Branded boot screen. Replaces the bare "Loading..." div that was the
// most-seen pixel of the app. Wrapped in a 300ms fade-in delay so fast
// loads never flash it — see .av-boot-fade in index.css.
//
// Also serves as the React.lazy Suspense fallback when code-splitting
// is wired in.
export default function BootScreen({ label = 'One moment' }) {
  return (
    <div
      className="av-boot-fade"
      style={{
        minHeight: '100vh',
        background: 'var(--bg)',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: '2.25rem',
            color: 'var(--ink)',
            letterSpacing: '-0.01em',
            marginBottom: '0.25rem',
            fontWeight: 500,
          }}
        >
          Avayble
        </div>
        <div
          className="av-eyebrow"
          style={{ color: 'var(--ink-3)' }}
        >
          {label}
        </div>
      </div>
    </div>
  );
}
